import { BankMaster } from "./BindMdl";


export class mdlPolicyDetailsCompRenewal {
    public POLICYNO: string;
    public Insured_Id: string;
    public Insured_Name: string;
    public Insured_DOB: string;
    public ProductCode: string;
    public Insured_Nationality_Code: string;
    public Insured_Nationality_En: string;
    public Insured_Nationality_Ar: string;
    public Insured_BuildingNo: string;
    public Insured_AdditionalCode: string;
    public Insured_StreetName: string;
    public Insured_DistrictName: string;
    public Insured_PostalCode: string;
    public Insured_AddressType: string;
    public Insured_IBANNO: string;
    public BankCode: string;
    public Insured_EmailId: string;
    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;
    public UPR_VAT_AMOUNT: number;
    public BankMaster: Array<BankMaster> = new Array<BankMaster>();
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlPolicyDetailsCompRenewal.ts